import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Offer } from '../models/offer.model';
import {BaseApi, ListData, StandardFilter} from '../core/api/base-api';


export class OffersFilter extends StandardFilter {
  search?: string;
}

@Injectable()
export class OffersService extends BaseApi {

  constructor(protected http: HttpClient) {
    super(http);
  }

  getAll(): Observable<Offer[]> {
    return this.http.get<Offer[]>(`${environment.apiUrl}/offers`);
  }

  find(filter: OffersFilter): Observable<ListData<Offer>> {
    return this.list<Offer>(`${environment.apiUrl}/offers`, { params: this.params(filter) });
  }

  get(id: any): Observable<Offer> {
    return this.http.get<Offer>(`${environment.apiUrl}/offers/${id}`);
  }

  getPdf(id: any, lang: any, showDiscounts: any, showVAT: any): Observable<Blob> {
    return this.http.get(`${environment.apiUrl}/offers/${id}/pdf?lang=${lang}&showDiscounts=${showDiscounts}&showVAT=${showVAT}`,
      {responseType: 'blob'});
  }

  getAllForBuyer(buyerId: any): Observable<Offer[]> {
    return this.http.get<Offer[]>(`${environment.apiUrl}/offers/buyer/${buyerId}`);
  }

  getAllForProject(projectId: any): Observable<Offer[]> {
    return this.http.get<Offer[]>(`${environment.apiUrl}/offers/project/${projectId}`);
  }

  create(data: any): Observable<any> {
    return this.http.post(`${environment.apiUrl}/offers`, data);
  }

  update(id: any, data: any): Observable<any> {
    return this.http.put(`${environment.apiUrl}/offers/${id}`, data);
  }

  delete(id: any): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/offers/${id}`);
  }
}
